import { defineComponent as _defineComponent } from 'vue'
import SWLogo from './SWLogo.vue'
import BioplannerLogo from './BioplannerLogo.vue'
import WeDermaLogo from './WeDermaLogo.vue'
import BirdIdLogo from './BirdIdLogo.vue'
import { computed } from 'vue'

export type PharmaceuticalName = keyof typeof logoMap


export default /*#__PURE__*/_defineComponent({
  __name: 'LogosMap',
  props: {
  name: { default: 'default' },
  width: null,
  height: null
},
  setup(__props) {

const props = __props;



const logoMap = {
  WeDerma: () => WeDermaLogo,
  Shortway: () => SWLogo,
  birdId: () => BirdIdLogo,
  default: () => BioplannerLogo,
}

const selectedLogo = computed(() => {
  return logoMap[props.name as PharmaceuticalName] ? logoMap[props.name as PharmaceuticalName]() : logoMap.default()
})

return { __sfc: true,props, logoMap, selectedLogo }
}

})